// return a valid amount string: remove the multiple "dots" and the invalid chars
export function getValidAmountString(amount, nDec) {
	amount = amount + "";
	if(amount.indexOf(".") > 0) {
		const digitAfterDot = amount.split(".")[1];
		if(digitAfterDot?.length === 3) {
			// togliamo il punto delle migliaia, perche' viene visto come float ES: 1.000 -> 1,00
			amount = amount.replaceAll(".", "");
		} 
	}
	let decimalChar = '.'; // the one used in for the type "float"
	amount = amount.replace(/,/g, decimalChar); // replace all the comma with the default decimalChar
	let numberOfDecimalCharAdmitted = nDec == 0? 0:1;
	let lastIndexOf = amount.lastIndexOf(decimalChar);
	let firstIndexOf = amount.indexOf(decimalChar);
	let removeLastDigit = false;
	if (numberOfDecimalCharAdmitted == 0) {
		if (lastIndexOf >= 0 || firstIndexOf >= 0) {
			// last digit is a "."; remove it. No decimal number are permitted in this system
			removeLastDigit = true;			
		}
	}
	else{
		if (lastIndexOf != firstIndexOf) {
			// last digit is a "."; remove it because there is already a "."
			removeLastDigit = true;
		}
		else{
			let values = amount.split(decimalChar);
			if (values.length === 2) {
				let decimals = values[1];
				if (decimals.length > nDec) {
					// avoid decimals > max decimal handled in this system
					removeLastDigit = true;
				}
			}
		}
	}
	// only number and dots
	let reg = new RegExp("^[0-9.]*$");
	if (reg.test(amount) === false) {
		// last digit is a unaceptable char; remove it
		removeLastDigit = true;
	}
	
	
	
	if (removeLastDigit) {
		amount = amount.substr(0, amount.length - 1);	
	}
	return amount;
}
